module.exports = __webpack_public_path__ + "static/media/grow-business-data.09f1f3bb.png";